import { Box, Text, Button } from "@chakra-ui/react";

const CTAHighlight = () => (
  <Box bg="green.600" color="white" textAlign="center" py={10}>
    <Text fontSize="2xl" fontWeight="bold">
      Join Our Free GenAI Career Webinar
    </Text>
    <Text fontSize="md" mt={2}>
      Learn how to start your AI journey — even with zero experience.
    </Text>
    <Button mt={4} colorScheme="whiteAlpha" size="lg" href="/webinar" as="a">
      Reserve My Spot
    </Button>
  </Box>
);
export default CTAHighlight;
